import { apolloClient } from '@/graphql/client';
import {
  createFile,
  retryFile,
  setSongActiveVersion,
} from '@/graphql/mutations';
import { getSong } from '@/graphql/queries';
import store from '@/store';
import { toastController } from '@ionic/vue';
import axios from 'axios';

export async function uploadSongFile(
  selectedFile: File | Blob,
  filename: string,
  songId: string,
  active = false,
  fileId = null,
  title: string,
  notes: string,
) {
  let fileLoadedPercentage = 0;
  let response;
  if (fileId === null) {
    const createFileResponse = await apolloClient.mutate({
      mutation: createFile,
      variables: {
        title: title || filename,
        originalFilename: filename,
        songId,
        notes: notes || '',
      },
      refetchQueries: [{ query: getSong, variables: { id: songId } }],
    });
    response = createFileResponse.data.createFile;
  } else {
    const retryFileResponse = await apolloClient.mutate({
      mutation: retryFile,
      variables: {
        id: fileId,
      },
    });
    response = retryFileResponse.data.retryFile;
  }

  if (!response?.file?.id) {
    const toast = await toastController.create({
      header: 'Uh oh!',
      message:
        'Sorry! We had trouble creating the song version. Please try again later.',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    await toast.present();

    return;
  }

  store.dispatch('setUploadingFileId', response.file.id);

  if (active) {
    apolloClient.mutate({
      mutation: setSongActiveVersion,
      variables: {
        songId,
        fileId: response.file.id,
      },
      refetchQueries: [{ query: getSong, variables: { id: songId } }],
    });
  }

  await axios.put(response.uploadUrl, selectedFile, {
    headers: {
      'Content-Type': '',
    },
    onUploadProgress: (progressEvent) => {
      const totalLength = progressEvent.lengthComputable
        ? progressEvent.total
        : progressEvent.target.getResponseHeader('content-length') ||
          progressEvent.target.getResponseHeader(
            'x-decompressed-content-length',
          );
      if (totalLength !== null) {
        fileLoadedPercentage = progressEvent.loaded / totalLength;
        store.dispatch('setUploadingFilePercentage', fileLoadedPercentage);
      }
    },
  });

  store.dispatch('finishFileUpload');
}
